import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { FormRowDirective } from '../../directives/form-row.directive';
import { Button } from '../button/button.component';
import { Card } from '../card/card.component';

@Component({
  selector: 'procure-page-maintenance-mode',
  templateUrl: './page-maintenance-mode.component.html',
  styleUrl: './page-maintenance-mode.component.scss',
  imports: [Button, RouterLink, Card, FormRowDirective, QuicklinkDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageMaintenanceMode {
  @Input() maintenanceText?: string | null;
  @Input() redirectUrl: string = '/';
  @Input() redirectLabel: string = 'Go to Dashboard';
}
